{
  "fr": {
    "continueSignIn": {
      "accountSwitch": {
        "title": "Changer de compte",
        "description": "Votre compte {provider} est lié à un autre compte fobizz. Voulez-vous vous connecter avec ce compte maintenant ?",
        "confirm": "Oui, se reconnecter",
        "cancel": "Annuler"
      },
      "linkBlocked": {
        "title": "Lier le compte",
        "description": "Ce compte est déjà lié à un autre compte {provider}. Veuillez supprimer le lien existant dans vos paramètres et recommencer le processus.",
        "confirm": "Accéder à mes paramètres",
        "cancel": "Annuler"
      },
      "linkAvailable": {
        "title": "Lier le compte",
        "description": "Vous êtes connecté·e avec ce compte fobizz. Souhaitez-vous le lier à votre compte {provider} ?",
        "confirm": "Oui, utiliser ce compte",
        "otherAccountsTitle": "Autres comptes fobizz",
        "signIn": "Utiliser un autre compte fobizz",
        "createNew": "Créer un nouveau compte",
        "cancel": "Annuler"
      },
      "anonymous": {
        "title": "Continuer avec {provider}",
        "description": "Souhaitez-vous lier un compte fobizz existant ou en créer un nouveau ?",
        "signIn": "Se connecter et lier",
        "createNew": "Créer un compte avec les données {provider}",
        "cancel": "Annuler"
      },
      "providers": {
        "google_oauth2": "Google",
        "microsoft_office365": "Microsoft",
        "apple": "Apple",
        "bildung_lsa": "Bildung-LSA",
        "edulog": "Edulog",
        "edupool": "Edupool",
        "lux": "Lux",
        "untis": "WebUntis",
        "vidis": "VIDIS",
        "univention": "Univention",
        "austria": "Austria"
      },
      "errors": {
        "emailTaken": "Un compte avec cette adresse e-mail existe déjà."
      }
    }
  }
}
